// extracted by mini-css-extract-plugin
export default {"up":"Comparison_up__TN3+K","down":"Comparison_down__phMM1","noChange":"Comparison_noChange__GFqQX"};